import { useTheme } from '@mui/material';
import { alpha } from '@mui/material/styles';
const useBottomNavigationStyles = () => {
    const theme = useTheme();
    return {
        BottomNavigationActionStyles: {
            '&.Mui-selected': {
                svg: {
                    background: alpha(theme.palette.primary.main, 0.08),
                    width: 48,
                    px: '12px',
                    borderRadius: '100px'
                },
                '.MuiBadge-badge': {
                    right: '15px !important'
                }
            }
        },
        AlertBadgeStyles: {}
    };
};
export default useBottomNavigationStyles;
